import { Inline, textVariants, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { traveler as travelerUtils, constants } from '@eti/utils';
import useNameFormatter from '../../../../common/custom-hooks/useNameFormatter';

const { MOUSE_FLOW_CLASS_NAMES } = constants;

interface InfoReviewModalTravelerProps {
  ageType: string;
  firstName?: string | null;
  lastName?: string | null;
}

const InfoReviewModalTraveler = ({
  ageType,
  firstName,
  lastName,
}: InfoReviewModalTravelerProps) => {
  const { t } = useTranslation();
  const { formatName } = useNameFormatter();
  const ageTypeLabel = travelerUtils.resolveLabelFromType(
    ageType,
    t('Adult'),
    t('Child'),
    t('Infant'),
  );

  const ageTypeTestId = `info-review-traveler-age-type-${ageType}`;

  return (
    <Inline spacing={4}>
      <Text
        as="p"
        className={MOUSE_FLOW_CLASS_NAMES}
        data-testid="info-review-traveler-name"
        variant={textVariants._16_BOLD}
      >
        {formatName(firstName, lastName)}
      </Text>
      <Text
        as="p"
        className={MOUSE_FLOW_CLASS_NAMES}
        data-testid={ageTypeTestId}
        variant={textVariants._16}
      >
        - {ageTypeLabel}
      </Text>
    </Inline>
  );
};

export default InfoReviewModalTraveler;
